var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9942 1.33286H3.99848C3.29149 1.33286 2.61345 1.61371 2.11353 2.11363C1.61362 2.61355 1.33276 3.29158 1.33276 3.99857V25.3243C1.33276 26.0313 1.61362 26.7094 2.11353 27.2093C2.61345 27.7092 3.29149 27.9901 3.99848 27.9901H19.9928C20.6998 27.9901 21.3778 27.7092 21.8777 27.2093C22.3777 26.7094 22.6585 26.0313 22.6585 25.3243V7.99715L15.9942 1.33286Z",
    stroke: "#155DFC",
    strokeWidth: 2.66572,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/Doc.fee5b95a6690e9749ef706c1c5a14581.svg";
export { ForwardRef as ReactComponent };